import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FontService {

  constructor() { }

    appendFont(font: any) {
      // remove any existing one
      var elem = document.querySelector('#font-' + font.media_id + '-css');
      elem?.parentNode?.removeChild(elem);
      const head = document.getElementsByTagName('head')[0];
      const style = document.createElement('style');
      style.setAttribute('id', 'font-' + font.media_id + '-css');
      style.appendChild(
        document.createTextNode(
          `@font-face {
              font-family: "` + this.getFontName(font) + `";
              src: url("` +
            environment.mediaUrl +
            '/assets/' +
            font.filename +
            `");
            }`
        )
      );
      head.appendChild(style);
    }
  
    public getFontName(font:any){
      if(!font.title){
        return;
      }
      return font.title.replace(/\.[^/.]+$/, "");
    }
}
